// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../core/_base/crud';
// Models
import { Project } from '../../../core/auth/_models/project.model';
import { BehaviorSubject } from 'rxjs';
const API_PROJECTS_URL = '/api/project';

@Injectable()
export class ProjectService {
  private activeComponent: string | null = null;
  private projectTitleSource = new BehaviorSubject<string>('');
  projectTitle$ = this.projectTitleSource.asObservable();
  setActiveComponent(componentName: string) {
    this.activeComponent = componentName;
  }

  getActiveComponent() {
    return this.activeComponent;
  }
  setProjectTitle(title: string) {
    this.projectTitleSource.next(title);
  }
  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
  }

  // CREATE =>  POST: add a new customer to the server
  createProject(project: Project): Observable<Project> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<Project>(API_PROJECTS_URL, project, { headers: httpHeaders, responseType: 'text' as 'json' });
  }

  // READ
  getAll(): Observable<Project[]> {
    return this.http.get<Project[]>(API_PROJECTS_URL);
  }
  getProjects(pageIndex: number, pageSize: number, userid: string): Observable<any[]> {
    const params = {
      pageIndex: pageIndex.toString(),
      pageSize: pageSize.toString(),
      userid: userid,

    };

    return this.http.get<any[]>(API_PROJECTS_URL + '/relevant', { params });
  }
  getPreBuildProjects(userid: string): Observable<any[]> {
    const url = `${API_PROJECTS_URL}/prebuild/${userid}`;
    return this.http.get<any[]>(url);
  }
  getProjectById(projectId: string): Observable<Project> {
    return this.http.get<Project>(API_PROJECTS_URL + `/${projectId}`);
  }

  // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
  // items => filtered/sorted result
  // Server should return filtered/sorted result
  findProjects(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

    const url = API_PROJECTS_URL + '/find';
    return this.http.get<QueryResultsModel>(url, {
      headers: httpHeaders,
      params: httpParams,
      responseType: 'text' as 'json'
    });
  }

  // UPDATE => PUT: update the customer on the server
  updateProject(project: Project): Observable<any> {
    const httpHeader = this.httpUtils.getHTTPHeaders();
    return this.http.put(API_PROJECTS_URL + `/${project.uuid}`, JSON.stringify(project), { headers: httpHeader, responseType: 'text' as 'json' });
  }

  // UPDATE Status
  updateStatusForProject(customers: Project[], status: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {
      customersForUpdate: customers,
      newStatus: status
    };
    const url = API_PROJECTS_URL + '/updateStatus';
    return this.http.put(url, body, { headers: httpHeaders, responseType: 'text' as 'json' });
  }

  // DELETE => delete the customer from the server
  deleteProjectFromSuperadmin(projectId: string): Observable<Project> {
    const url = `${API_PROJECTS_URL}/${projectId}`;
    return this.http.delete<Project>(url);
  }

  // DELETE => delete the customer from the server
  deleteProject(projectId: string, userId: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = `${API_PROJECTS_URL}/deleteProject/${projectId}`;
    const body = { deletedBy: userId };
    return this.http.put(url, body, { headers: httpHeaders, responseType: 'text' as 'json' });
  }

  deleteProjects(ids: string[] = []): Observable<any> {
    const url = API_PROJECTS_URL + '/deleteProjects';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = { projectIdsForDelete: ids };
    return this.http.put<QueryResultsModel>(url, body, { headers: httpHeaders, responseType: 'text' as 'json' });
  }
  changeTitle(title: string) {
    this.projectTitleSource.next(title);
  }
  // Add this method to your ProjectService class
  recoverProject(projectId: string, userId: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = `${API_PROJECTS_URL}/recoverProject/${projectId}`;
    const body = { recoveredBy: userId };
    return this.http.put(url, body, { headers: httpHeaders, responseType: 'text' as 'json' });
  }

}
